<template>
	<div class="o-dashboard">
		<div class="margin-v-40">
			<h3>Pagina kan niet worden gevonden!</h3>
			<p class="no-margin">Helaas konden we de pagina niet vinden. Klik <router-link :to="{path: '/'}">hier</router-link> om terug naar het beginscherm te gaan</p>

		</div>
	</div>
</template>

<script>
import View from '@mixins/View';

export default {
	mixins: [ View ]
}
</script>